import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MessageModal from 'components/modal/MessageModal';
import PageDoesNotExist from 'pages/PageDoesNotExist';
import QuoteEmailTemplate from 'pages/QuoteEmailTemplate';
import QuoteEmailTemplateString from 'pages/QuoteEmailTemplateString';
import QuoteLinkPage from 'pages/quoteLinkPage/QuoteLinkPage';
import QuotePdfTemplate from 'pages/quotePdfTemplate/QuotePdfTemplate';
import { toggleFeedbackBar } from 'reducers/ui/uiSlice';
import {
  QUOTE_LINK_ROUTE_PREFIX,
  ROUTES_QUOTE_LINK,
} from 'shared/constants/quoteLinkRoutes';

function QuoteLinkApp() {
  const dispatch = useDispatch();
  const { showFeedbackBar, feedbackBarDetails } = useSelector(
    (state) => state.ui,
  );

  return (
    <Router>
      <MessageModal
        showModal={showFeedbackBar}
        message={feedbackBarDetails?.message}
        error={feedbackBarDetails?.error}
        openModalHandler={() => dispatch(toggleFeedbackBar(false))}
      />
      <Routes>
        <Route
          path={ROUTES_QUOTE_LINK.PDF_TEMPLATE}
          exact
          element={<QuotePdfTemplate />}
        />
        <Route
          path={ROUTES_QUOTE_LINK.EMAIL_TEMPLATE}
          exact
          element={<QuoteEmailTemplate />}
        />
        <Route
          path={ROUTES_QUOTE_LINK.EMAIL_TEMPLATE_STRING}
          exact
          element={<QuoteEmailTemplateString />}
        />
        <Route
          path={`${QUOTE_LINK_ROUTE_PREFIX}/:quoteId`}
          exact
          element={<QuoteLinkPage />}
        />
        <Route path="*" element={<PageDoesNotExist />} />
      </Routes>
    </Router>
  );
}

export default QuoteLinkApp;
